/**
 * Scripts for Year filter on the News Coverage Archive
 *
 * @todo Delete this file once neo_news is migrated to neo4j_news. It drives
 * the sidebar year buttons in archive-neo_news.php, which has had no URL since
 * neo_news was frozen to admin-only; /press-releases/, its other surface, is
 * now a block template with a FacetWP year dropdown of its own.
 */

/**
 * Initialize
 *
 */
const init = function () {
	bindYearFilter();
	bindMobileYearFilter();
};

const bindYearFilter = function () {

	const yearButtons = document.querySelectorAll('#year-filters button');

	yearButtons.forEach(button => {
		button.addEventListener('click', function () {

			const filterYear = this.dataset.filter;
			const dateMinFields = document.querySelectorAll('.news-filter .facetwp-type-date_range .facetwp-date-min');
			const dateMaxFields = document.querySelectorAll('.news-filter .facetwp-type-date_range .facetwp-date-max');

			this.parentElement.querySelectorAll('button').forEach(btn => btn.classList.remove('filter-active'));
			this.classList.add('filter-active');

			document.getElementById('dropdown-year-filters').value = filterYear;

			dateMinFields.forEach(el => {
				el.value = filterYear + '-01-01';
			});
			dateMaxFields.forEach(el => {
				el.value = filterYear + '-12-31';
			});

			FWP.refresh();
		});
	});
};

const bindMobileYearFilter = function () {

	const yearDropdown = document.getElementById('dropdown-year-filters');

	yearDropdown.addEventListener('change', function () {
		const filterYear = this.value;
		const dateMinFields = document.querySelectorAll('.news-filter .facetwp-type-date_range .facetwp-date-min');
		const dateMaxFields = document.querySelectorAll('.news-filter .facetwp-type-date_range .facetwp-date-max');
		const desktopFilter = document.getElementById('year-filters');

		desktopFilter.querySelector('.filter-active')?.classList.remove('filter-active');
		desktopFilter.querySelector('button[data-filter="' + filterYear + '"]')?.classList.add('filter-active');

		dateMinFields.forEach(el => {
			el.value = filterYear + '-01-01';
		});
		dateMaxFields.forEach(el => {
			el.value = filterYear + '-12-31';
		});

		FWP.refresh();
	});
};

window.addEventListener("DOMContentLoaded", () => {
	init();
});